export const vehicleTypes = {
  Motorbike: 'Motorbike',
  AgriculturalMachine: 'AgriculturalMachine',
  Camper: 'Camper',
}
